// Query params that carry campaign intent into the signup flow.
//
// `useSelfServiceSMBSignupModal` reads these from window.location.search once,
// at mount (ENG-5247). Every navigation hop between the marketing landing URL
// and that mount must therefore forward them, or the intent is gone before the
// hook can see it — which is ENG-5527: three separate hops each rebuilt their
// destination URL from scratch and silently dropped the trial.
//
// Adding a param here is the single change needed to carry a new one through
// every hop; that is the point of the list. utm_* are deliberately NOT included
// — attribution is owned by page-level analytics, and widening this without
// that team's input would change what campaigns report.
const CARRIED_PARAMS = ['trial_days'];

/**
 * Append the campaign params from `search` onto `path`, preserving any query
 * string `path` already has.
 *
 * Values are forwarded verbatim. Validation is deliberately not done here: the
 * API owns the allow-list (ALLOWED_TRIAL_DAYS) and an out-of-set value like
 * trial_days=30 must still reach it so it comes back as
 * billing.invalid_trial_days and the user gets the "Continue without trial"
 * recovery. Shape parsing already happens at the point of use.
 */
export function appendSignupParams(path: string, search: string): string {
  const source = new URLSearchParams(search);
  const carried = new URLSearchParams();

  CARRIED_PARAMS.forEach((key) => {
    const value = source.get(key);
    if (value !== null) carried.set(key, value);
  });

  const suffix = carried.toString();
  if (!suffix) return path;

  return `${path}${path.includes('?') ? '&' : '?'}${suffix}`;
}
